import { PublicationSearchResultItem } from '@amzn/awscat-pattern-library-service-model';
import { DateTime } from 'luxon';
import React from 'react';
import { stringComparator } from '../utils/Comparator';
import PublicationLink from './PublicationLink';
import { PublicationTypeBadge } from './PublicationTypeBadge';

export const ContentNameCol = {
  cell: (i: PublicationSearchResultItem) => (
    <PublicationLink
      contentType={i.contentType}
      contentId={i.contentId}
      workflowId={i.publicationWorkflowId}
      contentName={i.contentName}
      url={i.url}
    />
  ),
  header: 'Content title',
  id: 'contentName',
};

export const ContentNameSort = {
  comparator: stringComparator((i) => i.contentName),
  id: 'contentName',
};

export const ContentNameSelOpt = {
  editable: false,
  id: 'contentName',
  label: 'Content title',
  visible: true,
};

export const ContentIdCol = {
  cell: (i: PublicationSearchResultItem) => i.contentId,
  header: 'Content id',
  id: 'contentId',
};

export const ContentIdSort = {
  comparator: stringComparator((i) => i.contentId),
  id: 'contentId',
};

export const ContentIdSelOpt = {
  editable: true,
  id: 'contentId',
  label: 'Content id',
  visible: false,
};

export const ContentTypeCol = {
  cell: (i: PublicationSearchResultItem) => i.contentType,
  header: 'Content type',
  id: 'contentType',
};

export const ContentTypeSort = {
  comparator: stringComparator((i) => i.contentType),
  id: 'contentType',
};

export const ContentTypeSelOpt = {
  editable: true,
  id: 'contentType',
  label: 'Content type',
  visible: true,
};

export const PublicationDateCol = {
  cell: (i: PublicationSearchResultItem) =>
    DateTime.fromISO(i.publishDate).toLocaleString(DateTime.DATETIME_FULL),
  header: 'Publication date',
  id: 'publicationDate',
};

export const PublicationDateSort = {
  comparator: stringComparator((i) => i.publishDate),
  id: 'publicationDate',
};

export const PublicationDateSelOpt = {
  editable: true,
  id: 'publicationDate',
  label: 'Publication date',
  visible: true,
};

export const PublicationTypeCol = {
  cell: (i: PublicationSearchResultItem) => (
    <PublicationTypeBadge publicationType={i.publicationType} />
  ),
  header: 'Publication type',
  id: 'publicationType',
};

export const PublicationTypeSort = {
  comparator: stringComparator((i) => i.publicationType),
  id: 'publicationType',
};

export const PublicationTypeSelOpt = {
  editable: true,
  id: 'publicationType',
  label: 'Publication type',
  visible: true,
};
